import { create } from "zustand";
import { toast } from "sonner";
import { api, errMsg } from "./api";

export const useWatchlists = create((set, get) => ({
  lists: [],
  active: Number(localStorage.getItem("pt_wl") || 1),
  load: async () => {
    const { data } = await api.get("/watchlists");
    set({ lists: data });
  },
  setActive: (active) => { localStorage.setItem("pt_wl", String(active)); set({ active }); },
  current: () => get().lists.find((l) => l.index === get().active),
  save: async (index, items) => {
    set({ lists: get().lists.map((l) => (l.index === index ? { ...l, items } : l)) });
    try {
      await api.put(`/watchlists/${index}`, { items });
    } catch (e) {
      toast.error(errMsg(e));
      get().load();
    }
  },
  add: async (key) => {
    const cur = get().current();
    if (!cur) return;
    if (cur.items.includes(key)) { toast.message(`Already in ${cur.name}`); return; }
    if (cur.items.length >= 50) { toast.error("Watchlist is full (50 max)"); return; }
    await get().save(cur.index, [...cur.items, key]);
    toast.success(`Added to ${cur.name}`);
  },
  remove: async (key) => {
    const cur = get().current();
    if (cur) await get().save(cur.index, cur.items.filter((k) => k !== key));
  },
}));
